
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.216 2.535a2.75 2.75 0 013.568 0l1.271 1.083c.2.17.45.274.712.295l1.665.133a2.75 2.75 0 012.522 2.522l.133 1.666c.021.262.124.51.295.71l1.083 1.272a2.75 2.75 0 010 3.568l-1.083 1.271c-.17.2-.274.45-.295.712l-.133 1.665a2.75 2.75 0 01-2.522 2.522l-1.665.133a1.25 1.25 0 00-.712.295l-1.271 1.083a2.75 2.75 0 01-3.568 0l-1.271-1.083a1.25 1.25 0 00-.712-.295l-1.665-.133a2.75 2.75 0 01-2.522-2.522l-.133-1.665a1.25 1.25 0 00-.295-.712l-1.083-1.271a2.75 2.75 0 010-3.568l1.083-1.271c.17-.2.274-.45.295-.711l.133-1.666a2.75 2.75 0 012.522-2.522l1.665-.133a1.25 1.25 0 00.712-.295l1.271-1.083z"}})])
          )
        }
      }
    